var _excluded = ["image", "link", "label", "text", "paddingSpace", "hasArrow", "hasBorder"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from "react";
import OnColorContext from "../../../contexts/OnColorContext";
var CaretRight = function CaretRight(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m11.284 8.991-4.526 5.16a.675.675 0 0 1-1.042 0 .926.926 0 0 1 0-1.189L9.72 8.397 5.716 3.832a.926.926 0 0 1 0-1.189.675.675 0 0 1 1.042 0l4.526 5.16a.901.901 0 0 1 .216.594c0 .215-.072.43-.216.594Z",
    fill: "#000"
  }));
};
CaretRight.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "17",
  fill: "none"
};
import FlexContainerOrg from "../../organisms/FlexContainerOrg";
import PushOrg from "../../organisms/PushOrg";
import Picture from "../../quarks/Picture";
import IconAtm from "../IconAtm";
import { StyledLabelAtm, StyledImageWithTextLinkAtm } from "./ImageWithTextLinkAtm.styled";
function ImageWithTextLinkAtm(_ref) {
  var image = _ref.image,
    link = _ref.link,
    label = _ref.label,
    text = _ref.text,
    paddingSpace = _ref.paddingSpace,
    hasArrow = _ref.hasArrow,
    hasBorder = _ref.hasBorder,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var onColor = useContext(OnColorContext);
  return /*#__PURE__*/React.createElement(StyledImageWithTextLinkAtm, _extends({
    $label: label,
    $onColor: onColor,
    $paddingSpace: paddingSpace,
    $hasBorder: hasBorder
  }, link, restProps), /*#__PURE__*/React.createElement(Picture, {
    srcData: image
  }), /*#__PURE__*/React.createElement(FlexContainerOrg, null, text), label ? /*#__PURE__*/React.createElement(StyledLabelAtm, {
    variant: label.variant,
    size: "small"
  }, label.text) : null, hasArrow ? /*#__PURE__*/React.createElement(PushOrg, {
    leftSpace: 1
  }, /*#__PURE__*/React.createElement(IconAtm, {
    icon: CaretRight,
    sizeSpace: 2
  })) : null);
}
export default ImageWithTextLinkAtm;